var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPodimo = function SvgPodimo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "#794CF8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.381 31.444c-.694-.564-.694-1.476-.694-3.299V3.854c0-1.824 0-2.736.694-3.299.694-.563 1.475-.4 3.035-.07 7.571 1.593 12.58 7.934 12.58 15.514 0 7.58-5.009 13.922-12.58 15.516-1.56.328-2.34.492-3.035-.071Zm-15.464-7.16c-.73-.563-.73-1.478-.73-3.307V4.02c0-1.829 0-2.743.73-3.307.73-.564 1.485-.369 2.995.022 5.658 1.463 9.283 6.175 9.283 11.764 0 5.588-3.625 10.3-9.283 11.764-1.51.39-2.265.585-2.995.021Zm12.468 8.854a6.693 6.693 0 1 1-13.385 0 6.693 6.693 0 0 1 13.385 0Z"
  })));
};
export default SvgPodimo;